import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Avatar from '../common/Avatar';
import createMarkup from '../../helpers/createMarkup';
import { Button } from 'reactstrap';

const Notification = ({ avatar, time, className, unread, flush, emoji, onClick, content }) => (
  <Button onClick={onClick} color='falcon-default' className={classNames('notification cursor-pointer shadow-none text-left w-100', { 'bg-200': unread, 'notification-flush': flush }, className)}>
    {avatar && (
      <div className="notification-avatar">
        <Avatar {...avatar} className="mr-3" />
      </div>
    )}
    <div className="notification-body w-100">
      <p className={emoji ? 'mb-1 w-100' : 'mb-0 w-100'} dangerouslySetInnerHTML={createMarkup(content)} />
      <span className="notification-time">
        {emoji && (
          <span className="mr-1" role="img" aria-label="Emoji">
            {emoji}
          </span>
        )}
        {time}
      </span>
    </div>
  </Button>
)

Notification.propTypes = {
  avatar: PropTypes.shape(Avatar.propTypes),
  className: PropTypes.string,
  unread: PropTypes.bool,
  flush: PropTypes.bool,
  emoji: PropTypes.string,
  content: PropTypes.any
};

Notification.defaultProps = { unread: false, flush: false };

export default Notification;